import React from 'react';

import { TableView as TableViewIcon } from '@mui/icons-material';
import { Button } from '@mui/material';

import { DetailPageLayout } from 'src/components/common';
import { ModalId } from 'src/constants/modals';
import { useCurrentUserCompanyRevenueShare } from 'src/hooks/revenueShare';
import { useModalV2 } from 'src/hooks/shared';
import { useCurrentUserPermissions } from 'src/hooks/user';
import { RevenueShareReportGeneratingModal } from 'src/modals/billing';
import { NotFoundErrorPage } from 'src/pages/not-found';

import { WalletAccountPageEmployerAdmin } from './WalletAccountPageEmployerAdmin';
import { WalletAccountPagePeoAdmin } from './WalletAccountPagePeoAdmin';
import { WalletAccountPagePeoPayrollProvider } from './WalletAccountPagePeoPayrollProvider';

export const WalletAccountPage: React.FC = () => {
  const { openModal } = useModalV2();

  const { revenueShareSetting, revenueShareReportEnabled } = useCurrentUserCompanyRevenueShare();

  const handleRevenueShareReportClick = React.useCallback(() => {
    openModal(RevenueShareReportGeneratingModal, {
      id: ModalId.RevenueShareReportGenerating,
    });
  }, [openModal]);

  const isReportGeneratingAccessible = (revenueShareSetting && revenueShareReportEnabled) || false;

  return (
    <DetailPageLayout
      titleContent="Wallet"
      topRightContent={
        isReportGeneratingAccessible && (
          <Button
            variant="contained"
            size="small"
            onClick={handleRevenueShareReportClick}
            startIcon={<TableViewIcon />}
          >
            Generate report
          </Button>
        )
      }
    >
      <WalletAccountPageContent />
    </DetailPageLayout>
  );
};

const WalletAccountPageContent: React.FC = () => {
  const { isPeoSuperAdmin, isPeoAdmin, isEmployerAdmin, isPeoPayrollProviderUser } =
    useCurrentUserPermissions();

  if (isEmployerAdmin) {
    return <WalletAccountPageEmployerAdmin />;
  }

  if (isPeoSuperAdmin || isPeoAdmin) {
    return <WalletAccountPagePeoAdmin />;
  }

  if (isPeoPayrollProviderUser) {
    return <WalletAccountPagePeoPayrollProvider />;
  }

  return <NotFoundErrorPage />;
};
